import { IMSObject, IMSId, LabelFormatSetting } from './ims-object';

export enum MANAGEDDEVICE_STATUS {
  OK = 'SOK',
  WARNING = 'SWRN',
  ERROR = 'SERR',
}

export class Car extends IMSObject {
  static fromDto(
    dto: CarDTO,
    databag?: any,
    labelSettings?: LabelFormatSetting,
  ) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: dto.secondaryid,
        objRef: 'ims/Car',
      },
      dto.label,
      labelSettings || {
        primary: {
          value: '{0}',
          databagKeys: ['label'],
        },
      },
    );

    if (databag) {
      obj.databag = databag;
    } else {
      obj.databag = dto;
    }
    return obj;
  }

  public get defaultManagedDevice(): IMSObject {
    return this.databag.defaultmanageddevice
      ? new IMSObject(
          this.databag.defaultmanageddevice.id,
          undefined,
          this.databag.defaultmanageddevice.label,
          'ims/ManagedDevice',
        )
      : undefined;
  }
  public set defaultManagedDevice(obj: IMSObject) {
    this.databag.defaultmanageddevice.id = obj.getImsId();
    this.databag.defaultmanageddevice.label = obj.label;
  }

  public get defaultManagedDeviceStatus(): string {
    return this.databag.defaultmanageddevicestatus;
  }
  public set defaultManagedDeviceStatus(v: string) {
    this.databag.defaultmanageddevicestatus = v;
  }

  public get carType(): IMSObject {
    return this.databag.cartype
      ? new IMSObject(
          this.databag.cartype.id,
          undefined,
          this.databag.cartype.label,
          'ims/CarType',
        )
      : undefined;
  }
  public set carType(obj: IMSObject) {
    this.databag.cartype.id = obj.getImsId();
    this.databag.cartype.label = obj.label;
  }

  public get actKm(): number {
    return this.databag.actkm;
  }
  public set actKm(v: number) {
    this.databag.actkm = v;
  }

  public get fin(): string {
    return this.databag.fin;
  }
  public set fin(v: string) {
    this.databag.fin = v;
  }

  public get tag(): string {
    return this.databag.tag;
  }
  public set tag(v: string) {
    this.databag.tag = v;
  }

  public get isTrailer(): boolean {
    return this.databag.istrailer ?? false;
  }

  public get hasActiveManagedDevice(): boolean {
    if (this.defaultManagedDeviceStatus == undefined) {
      return false;
    }
    return this.defaultManagedDeviceStatus !== MANAGEDDEVICE_STATUS.ERROR;
  }

  constructor(
    public readonly id: IMSId,
    label: string,
    labelFormatSettings: LabelFormatSetting,
  ) {
    super(id.imsId, id.secondaryId, label, 'ims/Car', labelFormatSettings);
  }
}

export interface CarDTO {
  id: number;
  secondaryid: number;
  label: string;
}
